/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_BackInputs */

const en_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back`)
};

const es_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regresar`)
};

/**
* | output |
* | --- |
* | "Go back" |
*
* @param {Go_BackInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const go_back = /** @type {((inputs?: Go_BackInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_BackInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_go_back(inputs)
	return es_go_back(inputs)
});